/* eslint-disable react/prop-types */ // TODO: add props
import { useState } from 'react';
import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';
import { Map } from 'immutable';
import cx from 'classnames';
import { QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import FreeTextQuestion from '../questionTypes/FreeTextQuestion';
import MultiAnswerMultiChoiceQuestion from '../questionTypes/MultiAnswerMultiChoiceQuestion';
import SingleAnswerMultiChoiceQuestion from '../questionTypes/SingleAnswerMultiChoiceQuestion';
import IntegerQuestion from '../questionTypes/IntegerQuestion';
import NoResponseQuestion from '../questionTypes/NoResponseQuestion';
import s from './Question.scss';
import { useQuizStats } from 'edrolo/domains/lessons/hooks';
import { questionComponentPropTypes } from '../questionTypes/helpers';
import { useInjectable } from 'core/hooks';
import { useAnalytics } from 'edrolo/analytics';
import {
  lessonPropType,
  quizAttemptPropType,
  quizQuestionPropType,
} from '../../../lessons/propTypes';

const MULTI_CHOICE_SAVE_DELAY = 2500;

export const QuestionPres = ({
  question,
  quizAttempts,
  quizAttemptToReview,
  quizStats,
  response,
  isSaving,
  onResponseChange,
  onSaveClick,
  isSlideshow,
  style,
}) => {
  const questionTypes = {
    [QUESTION_TYPES.TEXT_MATCH]: SingleAnswerMultiChoiceQuestion, // TODO: Add "Text Match" type
    [QUESTION_TYPES.FREE_TEXT]: FreeTextQuestion,
    [QUESTION_TYPES.MULTI_ANSWER_MULTI_CHOICE]: MultiAnswerMultiChoiceQuestion,
    [QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE]:
      SingleAnswerMultiChoiceQuestion,
    [QUESTION_TYPES.INTEGER]: IntegerQuestion,
    [QUESTION_TYPES.NO_RESPONSE]: NoResponseQuestion,
  };

  const QuestionType = questionTypes[question.get('answer_type')];

  const isMultichoice =
    QuestionType === SingleAnswerMultiChoiceQuestion ||
    QuestionType === MultiAnswerMultiChoiceQuestion;

  return (
    <div
      className={cx('chunk-question', { [s.slideshow]: isSlideshow })}
      style={style}
    >
      <div className={cx('container', { [s.slideshow]: isSlideshow })}>
        <QuestionType
          question={question}
          quizAttempts={quizAttempts}
          quizAttemptToReview={quizAttemptToReview}
          quizStats={quizStats}
          response={response}
          isSaving={isSaving}
          onResponseChange={(res) => onResponseChange(res)}
          onSaveClick={() => onSaveClick()}
          isSlideshow={isSlideshow && !isMultichoice}
        />
      </div>
    </div>
  );
};

QuestionPres.propTypes = {
  ...questionComponentPropTypes,
  style: PT.shape({
    minHeight: PT.number,
  }),
};

const Question = ({
  question,
  lesson,
  onResponseSave,
  style,
  lessonQuizAttempts,
  saveQuizAttempt,
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const [response, setResponse] = useState();
  const { track } = useAnalytics();

  const useQuizStatsInjectable = useInjectable(
    'useQuizStatsInjectable',
    useQuizStats
  );

  const {
    data: quizStats,
    loading: loadingQS,
    error: errorQS,
  } = useQuizStatsInjectable(lesson.get('id'), question.get('id'));

  const quizAttempts = lessonQuizAttempts?.filter(
    (qa) => qa.get('question') === question.get('id')
  );

  const quizAttemptToReview = lessonQuizAttempts?.filter(
    (qa) => qa.get('question') === question.get('question_to_review')
  );

  const isMultiChoice = [
    QUESTION_TYPES.MULTI_ANSWER_MULTI_CHOICE,
    QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE,
  ].includes(question.get('answer_type'));

  const saveDelay = isMultiChoice ? MULTI_CHOICE_SAVE_DELAY : 0;

  const handleSaveClick = () => {
    track('completed quiz', {
      quiz_question_id: question.get('id'),
    });
    setIsSaving(true);
    saveQuizAttempt(
      lesson.get('id'),
      question.get('id'),
      response,
      handleSaveComplete
    );
  };

  const handleSaveComplete = () => {
    setIsSaving(false);
    setTimeout(() => {
      onResponseSave();
    }, saveDelay);
  };

  const initResponse =
    !response?.get('answer') && quizAttempts?.size > 0
      ? quizAttempts.last()
      : Map({ question: question.get('id') });

  if (loadingQS) {
    return <div>Loading...</div>;
  }

  if (errorQS) {
    return <div>{errorQS}</div>;
  }

  return (
    <QuestionPres
      question={question}
      quizAttempts={quizAttempts}
      quizAttemptToReview={quizAttemptToReview?.last()}
      quizStats={quizStats}
      response={response || initResponse}
      isSaving={isSaving}
      onResponseChange={setResponse}
      onSaveClick={handleSaveClick}
      isSlideshow={lesson.get('lesson_type') === 'SLIDES'}
      style={style}
    />
  );
};

Question.propTypes = {
  question: quizQuestionPropType.isRequired,
  lesson: lessonPropType.isRequired,
  lessonQuizAttempts: IPT.listOf(quizAttemptPropType),
  onResponseSave: PT.func.isRequired,
  saveQuizAttempt: PT.func.isRequired,
  style: PT.shape({
    minHeight: PT.number,
  }),
};

export default Question;
